/* Behaviour for the Setups mega menu (snippets/um-setups-mega-menu.liquid).
 *
 * Lives here rather than in a <script> inside the snippet because the theme
 * re-renders the header through the Section Rendering API after load. That
 * second render replaces the panel's markup via innerHTML, and a <script>
 * inserted that way never runs — so an inline version bound itself to a copy
 * of the panel that was immediately discarded, leaving the real one dead.
 *
 * Everything below delegates from document and holds no references to
 * elements, so it survives any number of re-renders without re-initialising.
 */
(function () {
  'use strict';

  var ROOT = '[data-umsm]';
  var hoverTimer = null;

  function root(el) {
    return el && el.closest ? el.closest(ROOT) : null;
  }

  /* Which panel is showing is kept in the DOM, not in a variable here — a
     re-render would wipe a variable but the markup comes back with the
     default panel showing, which is a fine place to land. */
  function show(panelRoot, key, focusTab) {
    if (!panelRoot) return;
    var tabs = panelRoot.querySelectorAll('[data-umsm-tab]');
    var panels = panelRoot.querySelectorAll('[data-umsm-panel]');

    Array.prototype.forEach.call(tabs, function (t) {
      var on = t.getAttribute('data-umsm-tab') === key;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focusTab) t.focus();
    });

    Array.prototype.forEach.call(panels, function (p) {
      var on = p.getAttribute('data-umsm-panel') === key;
      p.hidden = !on;
      p.classList.toggle('is-active', on);
    });
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-umsm-tab]') : null;
    if (tab) {
      clearTimeout(hoverTimer);
      show(root(tab), tab.getAttribute('data-umsm-tab'), false);
      return;
    }

    var selectorBtn = e.target.closest ? e.target.closest('[data-umsm-selector]') : null;
    if (selectorBtn) {
      if (window.umVehicleSelector && window.umVehicleSelector.open) {
        window.umVehicleSelector.open();
      } else {
        window.location.href = '/collections/all';
      }
    }
  });

  /* pointerover rather than pointerenter, because only the former bubbles and
     delegation needs a bubbling event. Switching on hover is debounced: a
     pointer crossing the rail on its way to a card must not yank the panel out
     from under itself, so the swap waits for the pointer to settle. */
  document.addEventListener('pointerover', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-umsm-tab]') : null;
    if (!tab) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () {
      show(root(tab), tab.getAttribute('data-umsm-tab'), false);
      syncHeight();
    }, 110);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.target.closest && e.target.closest('[data-umsm-tab]')) clearTimeout(hoverTimer);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-umsm-tab]') : null;
    if (!tab) return;
    var panelRoot = root(tab);
    if (!panelRoot) return;
    var tabs = Array.prototype.slice.call(panelRoot.querySelectorAll('[data-umsm-tab]'));
    var idx = tabs.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
    if (e.key === 'Home') next = tabs[0];
    if (e.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    e.preventDefault();
    show(panelRoot, next.getAttribute('data-umsm-tab'), true);
  });

  /* ── The hover bridge ──────────────────────────────────────────────────
   * The nav link's box ends at the bottom of its text; the panel's box starts
   * at the bottom of the header. Between them sits a band of header about
   * 18px tall that belongs to neither, and dragging the pointer down from
   * "Setups" to the panel crosses it — which fires pointerleave on the menu
   * item, and the theme closes the menu before the pointer arrives.
   *
   * This is a transparent strip over that band, inserted as a child of the
   * same menu item, so crossing it never counts as leaving it.
   *
   * position:fixed on purpose: an absolutely positioned child would need the
   * menu item to be position:relative, which would make it the containing
   * block for the submenu and shrink the full-width panel to the width of the
   * word "Setups". It only accepts pointer events while the menu is open (see
   * the CSS in the snippet), so it can never swallow a header click.
   */
  function placeBridge(item) {
    var link = item.querySelector('.menu-list__link');
    if (!link) return;
    var bridge = item.querySelector('.umsm__bridge');
    if (!bridge) {
      bridge = document.createElement('div');
      bridge.className = 'umsm__bridge';
      bridge.setAttribute('aria-hidden', 'true');
      item.appendChild(bridge);
    }
    var a = link.getBoundingClientRect();
    var submenu = item.querySelector('.menu-list__submenu');
    var target = submenu ? submenu.getBoundingClientRect().top : a.bottom + 20;
    /* Full width of the viewport, not just the width of the word "Setups".
       A strip the width of the link only caught a dead-straight downward
       drag: anyone moving diagonally — which is most people, since the thing
       they are reaching for is somewhere out across the panel — left the
       strip sideways and the menu shut under them. The band is a few pixels
       tall and only live while the menu is open, so covering the width of the
       header costs nothing. */
    var top = a.bottom - 6;
    var left = 0;

    bridge.style.height = Math.max(target - top + 6, 10) + 'px';
    bridge.style.width = (document.documentElement.clientWidth || window.innerWidth) + 'px';
    bridge.style.top = top + 'px';
    bridge.style.left = left + 'px';

    /* position:fixed is normally viewport-relative, but an ancestor with
       transform, filter or contain becomes the containing block instead — and
       this one has `content-visibility: auto` on the submenu's branch and a
       transform further up, so the strip landed 36px low (the height of the
       announcement bar). Rather than hunt for which ancestor it is and hope it
       never changes, measure where the strip actually landed and correct by
       the difference. Costs one extra layout read on hover and is right
       whatever the theme does above it. */
    var got = bridge.getBoundingClientRect();
    var dy = got.top - top;
    var dx = got.left - left;
    if (Math.abs(dy) > 0.5) bridge.style.top = top - dy + 'px';
    if (Math.abs(dx) > 0.5) bridge.style.left = left - dx + 'px';
  }

  function menuItemWithPanel(el) {
    var panel = root(el);
    if (!panel) return null;
    var submenu = panel.closest('.menu-list__submenu');
    return submenu ? submenu.closest('.menu-list__list-item') : null;
  }

  document.addEventListener('pointerover', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('.menu-list__link');
    if (!link) return;
    var item = link.closest('.menu-list__list-item');
    if (!item || !item.querySelector(ROOT)) return;
    placeBridge(item);
  });

  /* ── Keep the opening height honest ──────────────────────────────────
   * The theme measures the panel once, on activation, and writes the result
   * into --submenu-height / --full-open-header-height. Those two drive the
   * clip-path that reveals the panel, so a measurement taken before the tile
   * images have laid out leaves the panel permanently clipped — the last row
   * of utes sliced in half with the page showing through underneath.
   *
   * Watching the panel's own box and rewriting both variables whenever it
   * changes fixes that, and also handles switching tabs: the Accessories
   * panel is a different height from the vehicle grid, and without this the
   * taller one gets cut to the height of whatever was measured first.
   *
   * Only ever written while the menu is open, so this cannot force it open.
   */
  function syncHeight() {
    var panel = document.querySelector(ROOT);
    var item = menuItemWithPanel(panel);
    if (!item) return;
    var link = item.querySelector('.menu-list__link');
    if (!link || link.getAttribute('aria-expanded') !== 'true') return;
    var submenu = item.querySelector('.menu-list__submenu');
    var header = document.querySelector('header-component');
    if (!submenu || !header) return;
    var h = submenu.offsetHeight;
    if (!h) return;
    var headerRow = header.hasAttribute('data-submenu-overlap-bottom-row')
      ? header.querySelector('.header__row--top')
      : header;
    var visible = headerRow ? headerRow.offsetHeight : 0;
    header.style.setProperty('--submenu-height', h + 'px');
    header.style.setProperty('--full-open-header-height', h + visible + 'px');
  }

  if (typeof ResizeObserver === 'function') {
    var ro = new ResizeObserver(function () { syncHeight(); });
    var observed = null;
    setInterval(function () {
      var panel = document.querySelector(ROOT);
      if (panel && panel !== observed) {
        if (observed) ro.unobserve(observed);
        ro.observe(panel);
        observed = panel;
      }
    }, 1000);
  }

  /* Tab changes resize the panel, so re-measure right after one. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-umsm-tab]')) setTimeout(syncHeight, 0);
  });

  /* ── Opening and closing ───────────────────────────────────────────────
   * Driven here rather than left to the theme's own hover state machine.
   *
   * That machine keeps a single "active item" and returns early when the item
   * you are entering is the one it already thinks is active. Combined with a
   * deactivate that does not always land, it left the panel in a state where
   * approaching Setups from BELOW — coming up off the page rather than across
   * from another nav item — highlighted the link but never opened the menu.
   * Reported by Matt: "only works if you come in from the side."
   *
   * Opening is three attributes and two CSS variables, all of which this file
   * already writes for other reasons, so doing it directly is both shorter and
   * deterministic: any pointer over the item or its panel means open, anything
   * else for longer than the grace period means closed. The theme's own
   * handlers still run and set the same attributes to the same values, so the
   * two agree rather than fight.
   */
  var closeTimer = null;

  function panelItem() {
    return menuItemWithPanel(document.querySelector(ROOT));
  }

  function openPanel() {
    var item = panelItem();
    if (!item) return;
    var link = item.querySelector('.menu-list__link');
    var submenu = item.querySelector('.menu-list__submenu');
    if (!link || !submenu) return;
    clearTimeout(closeTimer);
    closeTimer = null;
    link.setAttribute('aria-expanded', 'true');
    submenu.setAttribute('data-active', '');
    placeBridge(item);
    syncHeight();
  }

  function closePanel() {
    var item = panelItem();
    if (!item) return;
    var link = item.querySelector('.menu-list__link');
    var submenu = item.querySelector('.menu-list__submenu');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (submenu) submenu.removeAttribute('data-active');
    var header = document.querySelector('header-component');
    if (header) {
      header.style.setProperty('--submenu-height', '0px');
      header.style.setProperty('--full-open-header-height', '0px');
    }
  }

  /* Long enough to survive the pointer skimming a dead pixel on the way in or
     out, short enough that the panel does not linger once you have left. */
  function scheduleClose() {
    if (closeTimer) return;
    closeTimer = setTimeout(function () {
      closeTimer = null;
      closePanel();
    }, 220);
  }

  document.addEventListener('pointerover', function (e) {
    var item = panelItem();
    if (!item || !e.target.closest) return;
    if (item.contains(e.target) || e.target.closest('.umsm__bridge')) {
      openPanel();
    } else {
      scheduleClose();
    }
  });

  /* Leaving the window entirely counts as leaving the menu. */
  document.addEventListener('pointerleave', function (e) {
    if (e.target === document.documentElement) scheduleClose();
  });

  function replaceAll() {
    var panel = document.querySelector(ROOT);
    var item = menuItemWithPanel(panel);
    if (item) placeBridge(item);
    syncHeight();
  }

  window.addEventListener('resize', replaceAll);
  window.addEventListener('scroll', replaceAll, { passive: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', replaceAll);
  } else {
    replaceAll();
  }
})();
